import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TenantOnboardingRequest, TenantOnboardingRequestCreate, TenantOnboardingRequestFilter } from '../data/tenantOnboardingRequest';

export function createTenantOnboardingRequestService(client: AxiosInstance) {
  return createCrudService<TenantOnboardingRequest, TenantOnboardingRequestCreate, TenantOnboardingRequestFilter>(
    client,
    '/tenancy/TenantOnboardingRequest',
    'id',
  );
}

export type TenantOnboardingRequestService = CrudService<TenantOnboardingRequest, TenantOnboardingRequestCreate, TenantOnboardingRequestFilter>;
